
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import vuescroll from 'vuescroll'
import { mapState } from 'vuex'
export default {
name: 'pendingBill',
props: [],
components: {
XHeader,
XButton,
CheckIcon,
'scroller': vuescroll
},
data () {
return {
title: this.$route.meta.title,
ops: {
scrollPanel: {
scrollingX: false
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
},
buttons: {
type: 'brand',
disabled: true,
value: 0
},
pendingList: [],
allCheck: false,
checkArray: [],
total: 0
}
},
computed: {
...mapState({
studentSno: state => state.userInfo.sno
})
},
created () {},
mounted () {
this.getBillList().then(() => {
this.getCheckArr()
})
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
save () {
this.back()
},
getCheckArr () {
this.pendingList.forEach(element => {
this.checkArray.push(false)
})
},
selectAll ($event) {
let flag = this.allCheck
let checkArray2 = []
let num = 0
if (flag) {
this.checkArray.forEach((element, index) => {
element = flag
checkArray2.push(element)
num += this.pendingList[index].owe
})
this.buttons = {
type: 'brand',
disabled: false,
value: this.pendingList.length
}
} else {
this.checkArray.forEach(element => {
element = flag
checkArray2.push(element)
num = 0
})
this.buttons = {
type: 'brand',
disabled: true,
value: 0
}
}
this.checkArray = checkArray2
this.total = num.toFixed(2)
},
selected (index) {
let trueArr = []
let falseArr = []
let num = 0
this.checkArray.forEach((element, index) => {
if (element) {
trueArr.push(element)
num += this.pendingList[index].owe
} else {
falseArr.push(element)
}
})
this.total = num.toFixed(2)
this.buttons = {
type: 'brand',
disabled: false,
value: trueArr.length
}
if (this.checkArray[index]) {
if (trueArr.length === this.pendingList.length) {
this.allCheck = true
}
} else {
this.allCheck = false
if (falseArr.length === this.pendingList.length) {
this.buttons = {
type: '',
disabled: true,
value: trueArr.length
}
}
}
},
getBillList () {
let params = {
studentSno: this.studentSno
}
return new Promise((resolve, reject) => {
this.$api.get('/charge', params,
r => {
this.$vux.loading.hide()
let data = r.data

this.pendingList = data.filter(function (item) {
return (item.owe > 0)
})
resolve()
},
err => {
console.log('charge' + err)
this.$vux.toast.text(err.message, 'top')
})
})
},
toPay () {
this.$vux.toast.text('去第三方支付平台支付', 'middle')








}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/pay/pendingBill.vue